/**
 * App — zentraler Orchestrator. Initialisiert Router & Services.
 *
 * WARUM: Klare Trennung zwischen Bootstrap (main.js)
 * und Initialisierungslogik. main.js bleibt eine Zeile lang.
 */
import { router } from './router.js';
import { eventBus } from './eventBus.js';
import { socketService } from '../services/socketService.js';
import { storageService } from '../services/storageService.js';
import { toast } from '../ui/components/toast.js';

// Screens registrieren
import { renderHomeScreen }    from '../ui/screens/homeScreen.js';
import { renderSoloScreen }    from '../ui/screens/soloScreen.js';
import { renderLobbyScreen }   from '../ui/screens/lobbyScreen.js';
import { renderGameScreen }    from '../ui/screens/gameScreen.js';
import { renderResultsScreen } from '../ui/screens/resultsScreen.js';

export const app = {

  init() {
    this.registerRoutes();
    this.registerGlobalListeners();
    this.registerServiceWorker();

    router.start();

    // Letzten Spielernamen aus LocalStorage laden
    const savedName = storageService.get('playerName');
    if (savedName) eventBus.emit('player:name-loaded', { name: savedName });
  },

  registerRoutes() {
    router
      .register('/',         renderHomeScreen)
      .register('/solo',     renderSoloScreen)
      .register('/lobby',    renderLobbyScreen)
      .register('/game',     renderGameScreen)
      .register('/results',  renderResultsScreen);
  },

  registerGlobalListeners() {
    // Socket-Fehler → Toast anzeigen
    eventBus.on('socket:error',  (e) => toast.show(e.message || 'Connection error', 'error'));
    eventBus.on('lobby:error',   (e) => toast.show(e.error, 'error'));
    eventBus.on('socket:closed', ()  => toast.show('Verbindung verloren', 'error'));
    eventBus.on('socket:open',   ()  => toast.show('Verbunden', 'success'));
  },

  registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {
          // Silently ignore — PWA-Features fallen einfach weg
        });
      });
    }
  },
};
